import { render, staticRenderFns } from "./ProgramPush.vue?vue&type=template&id=bf99cef6&scoped=true"
import script from "./ProgramPush.vue?vue&type=script&lang=js"
export * from "./ProgramPush.vue?vue&type=script&lang=js"
import style0 from "./ProgramPush.vue?vue&type=style&index=0&id=bf99cef6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf99cef6",
  null
  
)

export default component.exports